import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import * as moment from 'moment/moment';
import { tap } from 'rxjs/internal/operators/tap';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-payments-payments-dashboard',
  templateUrl: './payments-payments-dashboard.component.html',
  styleUrls: ['./payments-payments-dashboard.component.scss']
})
export class PaymentsPaymentsDashboardComponent implements OnInit, OnDestroy {

  transactions;
  kpi;
  getTransactionsSubscription: Subscription;
  getTransactionsKPISubscription: Subscription;
  listenRefreshTransactionsSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private paymentsService: PaymentsService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.listenRefreshSatisfactions();
    this.getPaymentsList(moment().startOf('day').valueOf(), moment().valueOf());
    this.getTransactionsKPI(moment().startOf('day').valueOf(), moment().valueOf());
    this.setBreadcrumb();
  }

  private listenRefreshSatisfactions() {
    this.listenRefreshTransactionsSubscription = this.paymentsService.listenRefreshTransactions().pipe(
      tap(o => this.getPaymentsList(o['from'], o['to'])),
      tap(o => this.getTransactionsKPI(o['from'], o['to']))
    ).subscribe();
  }

  private getPaymentsList(from, to) {
    this.getTransactionsSubscription = this.paymentsService.getTransactions(from, to).pipe(
      tap(o => this.transactions = o)
    ).subscribe();
  }

  private getTransactionsKPI(from, to) {
    this.getTransactionsKPISubscription = this.paymentsService.getTransactionsKPI(from, to).pipe(
      tap(o => this.kpi = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file-invoice-dollar', 'gateways-page.transactions', '/payments', [new BRoute('gateways-page.gateways', '/payments'), new BRoute('gateways-page.transactions')]));
  }

  ngOnDestroy() {
    if (this.getTransactionsSubscription) { this.getTransactionsSubscription.unsubscribe(); }
    if (this.getTransactionsKPISubscription) { this.getTransactionsKPISubscription.unsubscribe(); }
    if (this.listenRefreshTransactionsSubscription) { this.listenRefreshTransactionsSubscription.unsubscribe(); }
  }

}
